import iEmailAddress from "./iEmailAddress";

export interface iContactData extends iEmailAddress {
    contactType: ContactDataType;
}

export enum ContactDataType {
    Enquiry = "In Enquiry",
    MyContacts = "My Contacts",
    TenantContacts = "Tenant Contacts",
    GlobalAddressBook = "Address Book",
}

export interface iContact extends iContactData {
    id: string;
}

export interface ContactProps extends iContact {
    onClick: (id: string) => void;
}
